import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import "./index.css";
import "./i18n";
import App from "./App";
import gtag from "./google-analytics"
import { getEnv, getGoogleAnalyticsCode } from "utils/meta-env";

const GOOGLE_ANALYTICS_CODE = getGoogleAnalyticsCode()
if (GOOGLE_ANALYTICS_CODE) {
  gtag(GOOGLE_ANALYTICS_CODE);
}

if (getEnv() === "production") {
  Sentry.init({
    dsn: "https://a1aa2cb970ec445d95965b7b486b705c@sentry.io/168373"
  });
}

ReactDOM.render(<App waitForFonts={true} />, document.getElementById("root"));
